import * as yup from "yup";
import { LanguagesSlugs } from "@typeDefinitions";

export const translationLang = yup
  .mixed<LanguagesSlugs>()
  .oneOf(Object.values(LanguagesSlugs))
  .required();
